import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { findAllPlaceFilterPageable } from '../../../actions/place';
import Form from '../../Reusable/Form/Form';
import { config } from './PlaceConfig';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { findAllPlace } from '../../../actions/place';
import { findAllMunicipality } from '../../../actions/municipality';

const PlaceFilter = ({
  t,
  enums,
  findAllPlaceFilterPageable,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  findAllMunicipality,
  municipalityList,
  pageSize,
}) => {
  useEffect(() => {
    findAllMunicipality();
  }, [findAllMunicipality]);
  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');
  const autonomousProvinceNameList = enums.AutonomousProvince;
  const municipalityNameList =
    municipalityList?.map((municipality) => municipality.name) || [];

  const { fields } = config(
    t,
    municipalityNameList,
    autonomousProvinceNameList
  );
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);
    const postData = {
      tableName: 'place',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          if (entry[0] === 'createdAtFrom' || entry[0] === 'createdAtTo') {
            if (
              values.createdAtFrom !== initialValues.createdAtFrom ||
              values.createdAtTo !== initialValues.createdAtTo
            )
              return {
                columnName: 'createdAt',
                dateMin: values.createdAtFrom,
                dateMax: values.createdAtTo,
                logicalOperator: '><',
              };
          } else {
            if (entry[0].includes('autonomousProvince')) {
              return (
                (values.autonomousProvince?.valueForFilter ||
                  values.autonomousProvince?.valueForFilter === 0) && {
                  columnName: 'autonomousProvince',
                  columnValue: values.autonomousProvince?.valueForFilter,
                }
              );
            }
            return (
              entry[1] && {
                columnName: entry[0],
                columnValue: entry[1],
              }
            );
          }
          return null;
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllPlaceFilterPageable(postData, pageSize, () => saveFilters(values));
    }
  };

  const packConfig = () => {
    return {
      fields: [...fields],
    };
  };

  const packTranslations = () => {
    return {
      ...t,
    };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters m-auto">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className={'PlaceForm'}
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser?.loggedUser,
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
  institutionTypeList: state.institutionType.institutionTypeList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllPlaceFilterPageable: (postData, pageSize, successCallback) => {
      dispatch(
        findAllPlaceFilterPageable(0, pageSize, postData, successCallback)
      );
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    findAllMunicipality: () => {
      dispatch(findAllMunicipality());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(PlaceFilter, 'PlaceFilter'))
);
